import React from 'react';
import { useNavigate } from 'react-router-dom';
import VentasCommercialForm from '../../../components/Ventas/VentasCommercialForm';

const CreateVentasQuote = () => {
  const navigate = useNavigate();

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Nueva cotización</h1>
          <p className="text-gray-600 mt-1">Propuesta comercial de venta con precios e IGV</p>
        </div>
        <VentasCommercialForm
          mode="quote"
          isPageMode
          onClose={() => navigate('/ventas/quotes', { state: { posConfirmed: true } })}
          onSuccess={() => navigate('/ventas/quotes', { state: { posConfirmed: true } })}
        />
      </div>
    </div>
  );
};

export default CreateVentasQuote;
